<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 28 34.706">
        <g id="Group_2820" data-name="Group 2820" transform="translate(-312 -607)">
            <circle id="Ellipse_189" data-name="Ellipse 189" cx="14" cy="14" r="14" transform="translate(312 607)"
                    fill="#cedbff"/>
            <g id="radiology" transform="translate(313.857 612.294)">
                <path id="Path_69963" data-name="Path 69963"
                      d="M78.045,194.93h-.162V193.46h.033a13.921,13.921,0,0,1,2.933.156.49.49,0,0,0,.955-.156.722.722,0,0,0-.22-.52c-.449-.448-1.509-.466-3.67-.461h-.032a.49.49,0,0,0-.98,0h-.031c-2.163,0-3.222.014-3.671.461a.722.722,0,0,0-.22.52.49.49,0,0,0,.955.156,13.931,13.931,0,0,1,2.933-.156H76.9v1.471H76.74c-2.8,0-4.056.014-4.53.487a.7.7,0,0,0-.21.494.49.49,0,0,0,.945.183,19.1,19.1,0,0,1,3.793-.184H76.9v1.471h-.031c-2.163,0-3.222.014-3.671.461a.722.722,0,0,0-.22.52.49.49,0,0,0,.955.156,13.914,13.914,0,0,1,2.933-.156H76.9v1.471H75.431a.49.49,0,0,0-.49.49,2.451,2.451,0,1,0,4.9,0,.49.49,0,0,0-.49-.49H77.883v-1.471h.033a13.912,13.912,0,0,1,2.933.156.49.49,0,0,0,.955-.156.722.722,0,0,0-.22-.52c-.449-.448-1.509-.466-3.67-.461h-.032v-1.471h.164a19.119,19.119,0,0,1,3.793.184.49.49,0,0,0,.945-.183.7.7,0,0,0-.21-.494C82.1,194.944,80.844,194.926,78.045,194.93Zm.734,5.883a1.471,1.471,0,0,1-2.773,0Z"
                      transform="translate(-68.569 -181.205)" fill="#799cfb"/>
                <path id="Path_69964" data-name="Path 69964"
                      d="M16.49,39.53h3.922v3.922a1.961,1.961,0,0,0,3.922,0V39.53h.98v3.922a1.961,1.961,0,0,0,3.922,0V39.53h3.922a.49.49,0,0,0,.49-.49V25.314a.49.49,0,0,0-.49-.49H31.651a3.436,3.436,0,0,0-3.4-2.941H26.636a4.447,4.447,0,0,0,.333-.452,4.914,4.914,0,0,0,.8-2.489,2.941,2.941,0,0,0-5.883,0,4.914,4.914,0,0,0,.8,2.489,4.446,4.446,0,0,0,.333.452H21.392A3.436,3.436,0,0,0,18,24.824H16.49a.49.49,0,0,0-.49.49V39.04A.49.49,0,0,0,16.49,39.53Zm6.863,3.922a.98.98,0,0,1-1.961,0V39.53h1.961Zm4.9,0a.98.98,0,0,1-1.961,0V39.53h1.961ZM22.863,18.941a1.961,1.961,0,0,1,3.922,0c0,1.215-1.014,2.941-1.961,2.941S22.863,20.156,22.863,18.941Zm-1.471,3.922h6.863a2.455,2.455,0,0,1,2.4,1.961H18.991a2.455,2.455,0,0,1,2.4-1.961ZM16.98,25.8H32.667V38.55H16.98Z"
                      transform="translate(-16 -16)" fill="#799cfb"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "IRadiology",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
